function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Listing photo - popular@svg");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Badges/Listing-badge/popular"
}, /*#__PURE__*/React.createElement("g", {
  id: "Listing-photo---popular"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-5",
  fill: "#DF6E4D",
  x: 0,
  y: 0,
  width: 100,
  height: 19,
  rx: 9.5
}), /*#__PURE__*/React.createElement("text", {
  id: "POPULAR",
  fontFamily: "Avenir-Heavy, Avenir",
  fontSize: 10,
  fontWeight: 600,
  "line-spacing": 14,
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 15.26,
  y: 13
}, "SHORT - TERM")))));

var SvgShortTerm = function SvgShortTerm(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "19px",
    viewBox: "0 0 100 19",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShortTerm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/short-term.7554f7cc.svg";
export { ForwardRef as ReactComponent };